/**
 * Web Style Import
 *
 */

import './dnb-space.scss'
